// src/components/LoginModal.js
import React, { useEffect, useState } from 'react';
import API from '../utils/api';
import '../styles/modal.css';

const LoginModal = ({ closeModal, onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 모달이 열려 있는 동안 뒤 페이지 스크롤을 막는다 (header.css 의 규칙 재사용)
  useEffect(() => {
    document.body.classList.add('nav-open');
    return () => document.body.classList.remove('nav-open');
  }, []);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await API.post('/auth/login', {
        memberId: username,
        password,
      });

      const content = res.data?.content;

      if (content?.accessToken) {
        localStorage.setItem('accessToken', content.accessToken);
        localStorage.setItem('refreshToken', content.refreshToken);
        localStorage.setItem('userInfo', JSON.stringify({
          id: content.id || '',
          name: content.name || username,
          email: content.email || '',
        }));

        if (typeof onLogin === 'function') onLogin();
        closeModal();
      } else {
        setError('유효한 토큰이 없습니다. 다시 시도해주세요.');
      }
    } catch (err) {
      setError(err.response?.data?.message || '아이디 또는 비밀번호가 잘못되었습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal_overlay"
      onClick={(e) => e.target === e.currentTarget && closeModal()}
    >
      <div
        className="modal_content"
        role="dialog"
        aria-modal="true"
        aria-label="로그인"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="modal_close" aria-label="닫기" onClick={closeModal}>×</button>
        <div className="modal_title">로그인</div>
        <p className="modal_subtext">이 페이지는 관리자 전용입니다.</p>

        <form onSubmit={handleLogin}>
          <div className="field">
            <label className="field__label" htmlFor="login-id">아이디</label>
            <input
              id="login-id"
              className="input"
              type="text"
              placeholder="아이디 입력"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="field">
            <label className="field__label" htmlFor="login-pw">비밀번호</label>
            <input
              id="login-pw"
              className="input"
              type="password"
              placeholder="비밀번호 입력"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="field__error modal_error">{error}</div>}

          <button type="submit" className="btn btn--primary btn--block" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
